import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d1195d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-tab-content" }
const _hoisted_2 = { class: "summary-cards-container" }
const _hoisted_3 = {
  key: 0,
  class: "summary-cards-container-right"
}

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import SummaryCards from './SummaryCards.vue'
import PositionTable from './PositionTable.vue'
import type { TableColumn } from './hooks/useAccountDetail'

interface SubTab {
  label: string
  name: string
}

interface CardItem {
  label: string
  value: string
  showTip?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountTabContent',
  props: {
    activeTopTab: null,
    subTabs: null,
    cards: null,
    columns: null,
    tableData: null,
    loading: { type: Boolean },
    defaultSubTab: null,
    hidePosition: { type: Boolean }
  },
  emits: ['sub-tab-change', 'other-currency-change'],
  setup(__props: any, { emit }) {

const props = __props as {
  activeTopTab: string
  subTabs: SubTab[]
  cards: CardItem[]
  columns: TableColumn[]
  tableData: any[]
  loading?: boolean
  defaultSubTab?: string
  hidePosition?: boolean
};



const currencyOptions = ref<{ label: string, value: string }[]>([
  { label: '港元 HKD', value: 'HKD' },
  { label: '美元 USD', value: 'USD' }
])

const router = useRouter()


const activeSubTab = ref(props.defaultSubTab || props.subTabs[0]?.name || '')
const selectedCurrency = ref(currencyOptions.value[0]?.value)

watch(
  () => props.defaultSubTab,
  (val) => {
    if (val) activeSubTab.value = val
  }
)

watch(selectedCurrency, (val) => {
  emit('other-currency-change', val)
}, { immediate: true })

const onSubTabChange = () => {
  emit('sub-tab-change', activeSubTab.value)
  selectedCurrency.value = 'HKD'
  emit('other-currency-change', 'HKD')
}

const handleBuy = (row: any) => {
  const arr = []
  const {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    currentPriceDisplay: entrustPrice
  } = row
  arr[0] = {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    entrustPrice
  }
  router.push({
    name: 'BulkTrading',
    params: {
      bidAskList: JSON.stringify(arr)
    }
  })
}

const handleSell = (row: any) => {
  const arr = []
  const {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    currentPriceDisplay: entrustPrice
  } = row
  arr[0] = {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    entrustPrice
  }
  router.push({
    name: 'BulkTrading',
    params: {
      bidAskList: JSON.stringify(arr)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.subTabs.length > 0)
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: activeSubTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSubTab).value = $event)),
          class: "sub-tabs",
          onTabChange: onSubTabChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subTabs, (tab) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: tab.name,
                label: tab.label,
                name: tab.name
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SummaryCards, {
        cards: __props.cards,
        loading: __props.loading,
        class: _normalizeClass({ 'no-sub-tabs': __props.subTabs.length === 0 })
      }, null, 8, ["cards", "loading", "class"]),
      (activeSubTab.value === 'other' || activeSubTab.value === 'OTHER_HKD')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_select, {
              modelValue: selectedCurrency.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCurrency).value = $event)),
              placeholder: "请选择",
              class: "summary-cards-container-right-select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencyOptions.value, (option) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: option.value,
                    label: option.label,
                    value: option.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!__props.hidePosition)
      ? (_openBlock(), _createBlock(PositionTable, {
          key: 1,
          columns: __props.columns,
          "table-data": __props.tableData,
          loading: __props.loading,
          onBuy: handleBuy,
          onSell: handleSell
        }, null, 8, ["columns", "table-data", "loading"]))
      : _createCommentVNode("", true)
  ]))
}
}

})